import { combineEpics } from 'redux-observable';

import { fetchAppointments$ } from 'modules/appointments/epics/fetchAppointments$';
import { bookAppointment$ } from 'modules/appointments/epics/bookAppointment$';
import { updateAppointment$ } from 'modules/appointments/epics/updateAppointment$';
import { endSession$ } from './endSession$';
import { homeHealthCancel$ } from './homeHealthCancel$';
import { RootEpic } from 'types/types';

const epics: RootEpic = combineEpics(
  fetchAppointments$,
  bookAppointment$,
  updateAppointment$,
  endSession$,
  homeHealthCancel$,
);

export default epics;
